import Modal from "../Modal";
import LoanNewForm from "../../forms/loan/LoanNewForm";
import { useTranslation } from "../../../hooks/useTranslation";

export default function LoanNewModal({show, handleClose, items = null, title = null}) {
    const { t } = useTranslation();
    const defaultTitle = t("loans.newLoan");
    return (
        <Modal title={title || defaultTitle} show={show} handleClose={handleClose} width="500px">
            <LoanNewForm handleClose={handleClose} items={items}/>
        </Modal>
    );
};